import styled from '@emotion/styled';

export const ConferenceBoardBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding-top: 8rem;
`;

export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	@media screen and (max-width: 900px) {
		padding: 0 2rem;
		:last-child {
			padding: 0rem;
		}
	}
`;
export const PaddedWrapper = styled.div`
	@media screen and (max-width: 900px) {
		padding: 0 2rem;
	}
`;
export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const IntroduceContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	justify-content: flex-start;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	letter-spacing: -0.6px;
	line-height: 140%;
	.title_box {
		display: flex;
		flex-direction: column;
		gap: 1.6rem;
	}
	strong {
		font-size: ${(props) => props.theme.fontSize.sizeLg};
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
`;
export const SignBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	width: 100%;
	align-items: flex-end;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	letter-spacing: -0.6px;
	line-height: 140%;
	.title_box {
		display: flex;
		align-items: center;
		gap: 2rem;
		align-items: center;

		.name_box {
			display: flex;
			gap: 0.8rem;
			color: #212529;
			line-height: 100%;
			align-items: center;
			strong {
				line-height: 130%;
				font-size: ${(props) => props.theme.fontSize.sizeXl};
				font-weight: ${(props) => props.theme.fontWeight.weightSemi};
			}
		}
	}
`;

export const BorderBox = styled.div`
	padding: 0.8rem 1.2rem;
	color: #495057;
	background-color: #f1f3f5;
	width: fit-content;
	border-radius: 999.9rem;
	min-width: 11.8rem;
	white-space: nowrap;
`;
export const PointFont = styled.span`
	color: #47a3f3;
`;
export const ScheduleTextBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;
export const ScheduleBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 130%;
	letter-spacing: -0.6px;
	.danger {
		color: ${(props) => props.theme.colors.red600};
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	}
`;
export const ScheduleContent = styled.div`
	display: flex;
	gap: 0.8rem;
	align-items: center;
`;

export const GridBox = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 3.2rem;
`;

export const GridContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	.content_box {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.4rem;
		color: #000;
		.title {
			font-size: ${(props) => props.theme.fontSize.sizeMd};
			font-weight: ${(props) => props.theme.fontWeight.weightBold};
		}
		.content {
			font-size: ${(props) => props.theme.fontSize.sizeSm};
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
		}
	}
`;

export const GridImgBox = styled.div`
	display: flex;
	width: 100%;
	height: 8.8rem;
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;
export const ImgIntroduceBox = styled.div`
	max-width: 28.1rem;
	width: 100%;
	height: 35.6rem;
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

export const ImgMapBox = styled.div`
	height: 40rem;
`;

export const MapBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	width: 100%;
	padding: 2rem;
	background-color: #f1f3f5;
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
`;

export const MapContent = styled.div`
	display: flex;
	flex-direction: column;
	padding-bottom: 2rem;
	border-bottom: 1px solid #dee2e6;
	gap: 0.8rem;
	:last-child {
		padding-bottom: 0;
		border-bottom: none;
	}
	.menu_box {
		display: flex;
		align-items: center;
		background-color: ${(props) => props.theme.colors.primary400};
		color: #fff;
		border-radius: 999.9rem;
		padding: 0.4rem 1.2rem;
		font-size: ${(props) => props.theme.fontSize.sizeLg};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: 130%;
		letter-spacing: -0.6px;
		width: fit-content;
	}
	.menu_box_list {
	}
`;
